<template>
  <el-dialog
    :append-to-body="true"
    :title="$t('rm.生产完成')"
    width="1100px"
    custom-class="box"
    :visible.sync="dialog.visible"
  >
    <div
      v-for="(order, index) in list"
      :key="order.id"
      :class="{ 'mg-b-20': list.length - 1 != index }"
    >
      <div class="mg-b-10">{{ $t("rm.批次号") }}：{{ order.batchNo }}</div>
      <div v-for="item of order.items" :key="item.id">
        <div class="border-tb p-2 mt-2">
          <div class="d-flex pd-x-5 flex-1 mb-2 f-bold">
            <div class="c-5">{{ $t("rm.订单编号") }}</div>
            <div class="c-4">{{ $t("rm.SKU名称") }}</div>
            <div class="c-4">{{ $t("rm.SKU") }}</div>
            <div class="c-6">{{ $t("rm.数量") }}</div>
            <div class="c-3">{{ $t("rm.仓库") }}</div>
            <div class="c-2">{{ $t("rm.仓位") }}</div>
          </div>
          <div class="d-flex pd-x-5 flex-1 text-center">
            <div class="c-5">{{ item.orderCode }}</div>
            <div class="c-4">
              <el-tooltip
                effect="dark"
                :content="item.skuName"
                placement="bottom"
              >
                <div class="font-line">{{ item.skuName }}</div>
              </el-tooltip>
            </div>
            <div class="c-4">
              <el-tooltip effect="dark" :content="item.sku" placement="bottom">
                <div class="font-line">{{ item.sku }}</div>
              </el-tooltip>
            </div>
            <div class="c-6">
              <div class="flex-box">
                <input
                  :class="[
                    Number(item.prepareNum) > Number(item.quantity)
                      ? 'border-red'
                      : '',
                  ]"
                  class="w form-control form-control-sm tx-13 mg-b-5"
                  size="mini"
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  v-model="item.prepareNum"
                />
                <span> / {{ item.quantity }}</span>
              </div>
            </div>
            <div class="c-3 d-flex">{{ item.warehouseName }}</div>
            <div class="c-2 d-flex">{{ item.positionName }}</div>
          </div>
          <div
            class="mb-t-10 pd-10 d-flex align-items-center"
            v-if="
              item.processJson.constructor === Array &&
              item.processJson.length > 0
            "
          >
            <div class="mg-r-15" style="flex: 1">
              <step
                :data="item.processJson"
                :step-key="['name', 'completeTime']"
                :step-max-num="4"
                space="25"
                :active="item.active"
                height="70px"
                step-active-background-color="rgba(8, 102, 198, 0.75)"
                :alignCenter="true"
              />
            </div>
            <div style="width: 100px">
              <div>
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="item.active >= item.processJson.length"
                  style="width: 100%"
                  @click="next(item, '+')"
                  >{{ $t("rm.下一步") }}</el-button
                >
              </div>
              <div class="mg-t-10">
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="item.active <= item.begin"
                  style="width: 100%"
                  @click="next(item, '-')"
                  >{{ $t("rm.上一步") }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="confirm">{{
        $t("rm.确认")
      }}</el-button>
      <el-button size="mini" @click="close">{{ $t("rm.关闭") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Step from "@components/step.vue";

export default {
  components: { Step },
  props: {
    dialog: {
      type: Object,
      default: function () {
        return {
          visible: false,
          item: {},
          data: [],
        };
      },
    },
  },
  data() {
    return {
      fullbody: false,
    };
  },
  computed: {
    list() {
      let arr = this.dialog.data || [];
      arr.forEach((element) => {
        (element.items || []).forEach((ele) => {
          this.$set(ele, "prepareNum", ele.quantity);
          let key = ele.processLastCompleteKey;
          if (typeof key === "number") {
            key = key + 1;
          } else if (typeof key === "string") {
            if (!isNaN(Number(key))) {
              key = key + 1;
            } else {
              key = 0;
            }
          } else {
            key = 0;
          }
          this.$set(ele, "begin", key);
          this.$set(ele, "active", key);
        });
      });
      return this.dialog.data;
    },
  },
  methods: {
    // 下一步
    next(item, type) {
      let active = item.active;
      if (type == "-") {
        active -= 1;
      } else if (type == "+") {
        active += 1;
      }
      if (type == "-" && active <= item.begin) {
        item.active = item.begin;
      } else if (type == "+" && active >= item.processJson.length) {
        item.active = item.processJson.length;
      } else {
        item.active = active;
      }
    },
    confirm() {
      let skuItem = [];
      this.list.forEach((element) => {
        (element.items || []).forEach((ele) => {
          if (Number(ele.prepareNum) > Number(ele.quantity)) {
            ShowTip(this.$t("数量不可超过生产数量 && 不能为空"), "danger");
            return;
          } else {
            let craft = [];
            (ele.processJson || []).forEach((item, index) => {
              if (index < ele.active) {
                craft.push({ id: item.id, complete: 1 });
              }
            });

            skuItem.push({
              skuId: ele.skuId,
              num: ele.prepareNum,
              batchNo: ele.batchNo,
              process: craft,
            });
          }
        });
      });
      console.log(skuItem);
      let params = {
        orderId: this.dialog.item.id,
        skus: skuItem,
      };
      $.api_call("api.Production.completeProduction", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("transfer.操作成功"), "success");
          this.$emit("close", true);
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  overflow-y: auto;
  height: 500px;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }
}
.flex-box {
  display: flex;
  align-items: center;
}
.font-line {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.w {
  width: 80px;
}
.h {
  height: 30px;
}
.border-tb {
  background: #eee;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.f-bold {
  color: rgb(87, 86, 86);
  font-weight: 600;
}
.border-red {
  border-radius: 4px;
  border: 1px solid red !important;
}
</style>
